module.exports = __webpack_public_path__ + "img/fav.7187f1c8.svg";